import maInput from '@/components/input'

/**
 * @module
 * @name InputBtnIcon
 * @extends Input
  */
export default {
  name: 'InputBtnIcon',
  extends: maInput,
  /**
   * @property {Array} options Array of options. Option contain key and value.
   * @property {String} icon VueSVGIcon icon.
   */
  props: {
    options: {
      type: Array,
      required: false,
      default: []
    },
    icon: {
      type: String,
      required: false
    },
    inputError: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    /**
     * @function
     * @name isChecked
     * @description On component rendering toggles class if it's selected.
     * @param {String} inputKey Option key.
     * @returns {Boolean}
     */
    isChecked: function (inputKey) {
      return this.type === 'checkbox' ? this.value[inputKey] === true : this.value === inputKey
    },
    /**
     * @function
     * @name handleClick
     * @param {String} inputKey Option key
     * @description Handler for click. If inputBtn is used as checkbox, all the
     *              values are reviewed for setting each of them checked. If not,
     *              it can be used as radio button. Then, value / values are
     *              emitted.
     */
    handleClick: function (inputKey) {
      if (this.type === 'checkbox') {
        let selectedInput = this.$el.querySelectorAll('input[type="checkbox"]')
        const selectedValues = {}
        selectedInput.forEach(input => {
          selectedValues[input.value] = input.checked
        })
        this.$emit('change', selectedValues)
      } else {
        this.$emit('change', inputKey)
      }
    }
  }
}
